import request from './request';

const point_of_interest_types = {
	async getPointOfInterestTypes(query) {
		const response = await request.get('/app/point-of-interest-types', query);
		return response;
	}
};

export default point_of_interest_types;